import React from "react";
import { useImage } from "../contexts/ImageContext";
import "../styles/optionBadges.scss";
import formatMoney from "./formatMoney";

const OptionBadges = ({
  options,
  value,
  onChange,
  selectedOption,
  setSelectedOption,
  price,
  setSelectedImage,
  altImage,
}) => {
  const { getImageUrl } = useImage();

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onChange(option);
    option.image && setSelectedImage(option.image);
  };

  return (
    <div className="option-badges">
      <div className="option-badges-container">
        {options.map((option) => {
          const isSelected = selectedOption.option_id === option.option_id;
          return (
            <div
              className={`option-badge ${isSelected ? "selected" : ""}`}
              key={option.option_id}
              onClick={() => handleOptionClick(option)}
            >
              <div className="option-badge-image">
                <img
                  src={getImageUrl(option.image || altImage)}
                  alt={option.name}
                />
              </div>
              <div className="option-badge-content">
                <div className="option-badge-header">
                  <span className="option-badge-name">{option.name}</span>
                  {/* <span className="option-badge-price">
                    {formatMoney(
                      Number(option.additional_price) + Number(price)
                    )}
                  </span> */}
                </div>
                {option.description && (
                  <p className="option-badge-description">
                    {option.description}
                  </p>
                )}
              </div>
              {isSelected && (
                <div className="option-badge-check">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OptionBadges;
